import React, { Component } from "react";
import "../style/comment.scss";
import Pagination from "@material-ui/lab/Pagination";
import DeleteIcon from "../icon/DeleteIcon";
import * as GetCommentListAPI from "../apis/GetCommentListAPI";
import EditIcon from "../icon/EditIcon";
import AddComment from "../icon/AddComment";
import * as GetTieZiCommentListAPI from "../apis/GetTieZiCommentListAPI";
import { BASE_URL } from "../constants/ApiEndpointConstants";
import * as DeleteCommentAPI from "../apis/DeleteCommentAPI";
import Loading from "./common/Loading";
import NoContent from "../icon/NoContent";

class Comment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      per_page: 11,
      count: 1,
      commentList: [],
      id: "",
      loadingShow: false,
    };
    this.getCommentList = this.getCommentList.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.routeAddComment = this.routeAddComment.bind(this);
    this.delete = this.delete.bind(this);
    this.toggleShow = this.toggleShow.bind(this);
  }

  componentDidUpdate(prevProps) {
    // 检查URL参数是否变化
    if (this.props.match.params.id !== prevProps.match.params.id) {
      // 执行当URL参数变化时需要进行的操作
      this.fetchData(this.props.match.params.id);
    }
  }

  componentDidMount() {
    const { page, per_page } = this.state;
    let { location } = this.props;
    if (location.search) {
      let id = location.search.replace("?id=", "");
      this.setState({ id });
      this.getCommentList(page, per_page, id);
    }
  }

  getCommentList(page, per_page, id) {
    GetTieZiCommentListAPI.getTieZiCommentList(page, per_page, id).then(
      (res) => {
        console.log(res);
        var status = res.status;
        if (status === 200) {
          var data = res.data.data;
          var total = data.total;
          let count = Math.ceil(total / per_page);
          this.setState({ count, commentList: data.list });
        }
      },
    );
  }

  handlePageChange(e, page) {
    this.setState({ page: page }, () => {
      this.getCommentList(page, this.state.per_page, this.state.id);
    });
  }

  routeAddComment(id) {
    let { history, location } = this.props;
    if (id !== "") {
      const search = location.search;
      history &&
        history.push({
          pathname: `/AddComment/${id}`,
          search: location.search,
        });
      return;
    }
    const search = location.search;
    history &&
      history.push({
        pathname: `/AddComment`,
        search: location.search,
      });
  }

  delete(id) {
    this.toggleShow();
    DeleteCommentAPI.deleteComment(id).then((res) => {
      this.toggleShow();
      var code = res.data.code;
      if (code === 1) {
        window.dispatchEvent(
          new CustomEvent("showAlert", {
            detail: "删除成功",
          }),
        );
        this.getCommentList(
          this.state.page,
          this.state.per_page,
          this.state.id,
        );
      } else {
        window.dispatchEvent(
          new CustomEvent("showAlert", {
            detail: "操作失败",
          }),
        );
      }
    });
  }
  toggleShow() {
    this.setState({ loadingShow: !this.state.loadingShow });
  }

  render() {
    const { page, count, commentList } = this.state;
    return (
      <React.Fragment>
        <Loading {...this.props} loadingShow={this.state.loadingShow} />
        <div className="comment-page">
          <div className="toolbar">
            <AddComment
              size={30}
              color="#696cff"
              className="icon"
              onClick={() => this.routeAddComment("")}
            />
          </div>
          <div className="content">
            <div className="li-header">
              <div className="left">
                <div className="logo">LOGO</div>
                <div className="name">NAME</div>
                <div className="description">DESCRIPTION</div>
                <div className="time">TIME</div>
              </div>
              <div className="tool">OPERATION</div>
            </div>
            {commentList.length > 0 ? (
              <React.Fragment>
                {commentList.map((item, index) => {
                  return (
                    <div className="li" key={index}>
                      <div className="left">
                        <div className="logo">
                          <div className="img">
                            <div className="img">
                              <img src={BASE_URL + item.logo} alt="" />
                            </div>
                          </div>
                        </div>
                        <div className="name">{item.nickname}</div>
                        <div className="description">
                          <p
                            dangerouslySetInnerHTML={{
                              __html: item.description,
                            }}
                          ></p>
                        </div>
                        <div className="time">{item.updatetime}</div>
                      </div>
                      <div className="tool">
                        <EditIcon
                          size={16}
                          color="#696cff"
                          className="icon"
                          onClick={() => this.routeAddComment(item.id)}
                        />
                        <DeleteIcon
                          size={16}
                          color="#696cff"
                          className="icon"
                          onClick={() => this.delete(item.id)}
                        />
                      </div>
                    </div>
                  );
                })}
              </React.Fragment>
            ) : (
              <div className="no-content">
                {" "}
                <NoContent size={150} color="#707070" />
              </div>
            )}
          </div>
          <div className="footer">
            <Pagination
              count={count}
              page={page}
              onChange={this.handlePageChange}
              variant="outlined"
              color="standard"
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Comment;
